<template>
  <div class="kpi-achieve-detail-page">
    <van-tabs
      v-model="previewIndex"
      title-active-color="#3283fa"
      color="#3283fa"
      :sticky="true"
      :swipe-threshold="2"
    >
      <van-tab v-for="(title) in previewTypes" :key="title.title" :title="title.title">
        <van-list v-model="params.loading" :finished="params.finished" finished-text="— 暂无更多数据 —">
          <div class="customer" v-if="previewIndex==0">
            <div class="item bottom-line" v-for="(item,index) of leftList" :key="index">
              <img
                class="img"
                :src="item.avatar || 'https://j.weizan.cn/youxiang/images/avatar_default.jpg'"
                alt
              />
              <div class="customer-info">
                <div class="top">
                  <p class="f1 ofh f fc" v-if="rankType=='view'||rankType=='fission'">
                    <span>{{item.nickname}}</span>
                    <span v-if="item.mobile">({{item.mobile}})</span>
                  </p>
                  <p class="f1 ofh f fc" v-else>
                    <span>{{item.name}}</span>
                    <span v-if="item.mobile">({{item.mobile}})</span>
                  </p>
                  <span>{{item.happenTime}}</span>
                </div>
                <div class="center">
                  <div class="f f-v lh15">
                    <p class="f fc">
                      邀请人：
                      <span style="margin-right:10px;color:#1890FF;">{{item.bsNickname}}</span>
                    </p>
                    <p class="f fc" v-if="item.blNickname">
                      归属导购员：
                      <span style="margin-right:10px;color:#1890FF;">{{item.blNickname||0}}</span>
                    </p>
                  </div>
                  <div class="f f-v">
                    <p style="color:#FF6060;">+ {{item.bonusAmount||0}}</p>
                    <!-- 奖励金额 -->
                    <p style="color:#FF6060;">{{item.remark||""}}</p>
                    <!-- 奖励金额 -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="customer" v-if="previewIndex==1">
            <van-collapse v-model="collapseArray">
              <div v-for="(list,i) of rightList" :key="i">
                <van-collapse-item
                  :title="key+'（'+item.length+'次）'"
                  :name="key"
                  v-for="(item,key) in list"
                  :key="key"
                >
                  <div class="item invalid bottom-line" v-for="(info,ind) in item" :key="ind">
                    <img
                      class="img"
                      :src="info.avatar || 'https://j.weizan.cn/youxiang/images/avatar_default.jpg'"
                      alt
                    />
                    <div class="customer-info">
                      <div class="top">
                        <p class="f1 ofh f fc" v-if="rankType=='view'||rankType=='fission'">
                          <span>{{info.nickname}}</span>
                          <span v-if="info.mobile">({{info.mobile}})</span>
                        </p>
                        <p class="f1 ofh f fc" v-else>
                          <span>{{info.name}}</span>
                          <span v-if="info.mobile">({{info.mobile}})</span>
                        </p>
                        <span>{{info.happenTime}}</span>
                      </div>
                      <div class="center">
                        <div class="f f-v lh15">
                          <p class="f fc">
                            邀请人：
                            <span style="margin-right:10px;color:#1890FF;">{{info.bsNickname}}</span>
                          </p>
                          <p class="f fc" v-if="info.blNickname">
                            归属导购员：
                            <span
                              style="margin-right:10px;color:#1890FF;"
                            >{{info.blNickname||0}}</span>
                          </p>
                        </div>
                        <p style="color:#FF6060;">+ {{info.bonusAmount||0}}</p>
                      </div>
                      <div class="bottom">
                        <p>
                          无效：
                          <span>{{info.remark}}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </van-collapse-item>
              </div>
            </van-collapse>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>

    <back-home
      :activity_id="activity_id"
      :user_id="user_id"
      :kpi_uid="kpi_userid"
      :share_uid="share_userid"
    ></back-home>

    <!-- <app-footer></app-footer> -->
  </div>
</template>

<script>
// import appFooter from '../../components/kpi-footer/index.vue';
import backHome from "../../components/back-home.vue";

export default {
  components: {
    // appFooter,
    backHome,
  },
  data() {
    return {
      activity_id: localStorage.getItem("act_id"),
      user_id: localStorage.getItem("user_id"),
      kpi_userid: localStorage.getItem("kpi_user_id") || null,
      share_userid: localStorage.getItem("share_user_id") || null,
      title: this.$route.query.title,
      rankType: this.$route.query.type, //业绩类型
      previewTypes: [{ title: "有效浏览" }, { title: "无效浏览" }],
      previewIndex: 0,
      params: {
        loading: false,
        finished: false,
      },
      leftList: [], // 有效列表
      rightList: [], // 无效列表
      collapseArray: [],
    };
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = this.title;
    this.getList();
  },
  mounted() {
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  methods: {
    // 获取客户列表
    getList() {
      this.params.loading = true;
      this.$kpi.achieve
        .getMyCustomerList({
          actId: Number(this.activity_id),
          kpiUserId: this.kpi_userid || null,
          page: -1,
          size: -1,
          type: this.rankType,
        })
        .then((res) => {
          console.log(res);
          this.params.loading = false;
          if (res.code == 0) {
            var data = res.data;
            this.previewTypes = [
              { title: `有效浏览（${data.leftCount || 0}）` },
              { title: `无效浏览（${data.rightCount || 0}）` },
            ];
            this.leftList = data.leftCustomerInfoVos || [];
            if (data.rightCustomerInfoVos && data.rightCustomerInfoVos.length) {
              var result = [];
              var times = [];
              data.rightCustomerInfoVos.forEach((item) => {
                var time = item.happenTime.split(" ")[0];
                if (!result.length) {
                  let obj = {};
                  obj[time] = [];
                  obj[time].push(item);
                  times.push(time);
                  result.push(obj);
                } else {
                  var index = result.findIndex(
                    (item) => Object.keys(item)[0] == time
                  );
                  if (index >= 0) {
                    result[index][time].push(item);
                  } else {
                    let obj = {};
                    obj[time] = [];
                    obj[time].push(item);
                    times.push(time);
                    result.push(obj);
                  }
                }
              });
              this.collapseArray = times;
              this.rightList = result || [];
            }
            this.params.finished = true;
          } else if (res.code == 10200) {
            this.params.finished = true;
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
.kpi-achieve-detail-page {
  height: 100vh;
  .customer {
    .item {
      display: flex;
      padding: 8px 15px;
      background: #fff;
      &.invalid {
        padding: 8px 0;
      }
      .img {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin-right: 10px;
      }
      .customer-info {
        flex: 1;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        line-height: 1;
        color: #000;
        font-size: 12px;
        .top,
        .center,
        .bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 6px 0;
        }
      }
    }
    /deep/.van-collapse-item__content {
      padding: 0 16px;
    }
  }
}
</style>
